export function getTimezoneSafely(fallback = "UTC"): string {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (typeof timezone === "string" && timezone.length > 0) {
      return timezone;
    }

    throw new Error("Invalid timezone format");
  } catch (error) {
    console.error("Error retrieving timezone:", error);

    return fallback;
  }
}
